"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACET_FILTER_OPERATORS = void 0;
const superstruct_1 = require("superstruct");
const FacetFilterUtils_1 = require("./FacetFilterUtils");
const EQUAL_OPERATOR = (left, right) => (0, FacetFilterUtils_1.isTextMatch)(String(left), String(right));
const NOT_EQUAL_OPERATOR = (left, right) => !EQUAL_OPERATOR(left, right);
const IN_OPERATOR = (left, right) => {
    const rights = [].concat(right);
    // superstruct doesn't have negation for assert so we do this
    if ((0, superstruct_1.is)(left, (0, superstruct_1.array)()))
        (0, superstruct_1.assert)(left, (0, superstruct_1.never)());
    (0, superstruct_1.assert)(rights, (0, superstruct_1.array)());
    return rights.some((r) => EQUAL_OPERATOR(left, r));
};
const NOT_IN_OPERATOR = (left, right) => !IN_OPERATOR(left, right);
const LOGIC_AND_OPERATOR = (left, right) => Boolean(left) && Boolean(right);
const LOGIC_OR_OPERATOR = (left, right) => Boolean(left) || Boolean(right);
exports.FACET_FILTER_OPERATORS = [
    [
        ["==", EQUAL_OPERATOR],
        ["!=", NOT_EQUAL_OPERATOR],
    ],
    [
        ["in", IN_OPERATOR],
        ["!in", NOT_IN_OPERATOR],
    ],
    [["&&", LOGIC_AND_OPERATOR]],
    [["||", LOGIC_OR_OPERATOR]],
];
